
import { supabase } from "@/integrations/supabase/client";

export interface EmailServiceOptions {
  email: string;
  type: 'signup' | 'signin' | 'reset';
  confirmUrl?: string;
  resetUrl?: string;
}

export const sendAuthEmail = async (options: EmailServiceOptions) => {
  try {
    console.log('Sending auth email via edge function:', options);
    
    const { data, error } = await supabase.functions.invoke('send-auth-email', {
      body: options
    });

    if (error) {
      console.error('Error calling send-auth-email function:', error);
      throw error;
    }

    console.log('Auth email sent successfully:', data);
    return { success: true, data };
  } catch (error) {
    console.error('Failed to send auth email:', error);
    throw error;
  }
};

export const sendSignupConfirmationEmail = async (email: string, confirmUrl: string) => {
  return sendAuthEmail({
    email,
    type: 'signup',
    confirmUrl
  });
};

export const sendPasswordResetEmail = async (email: string, resetUrl: string) => {
  return sendAuthEmail({
    email,
    type: 'reset',
    resetUrl
  });
};

export const sendSignInEmail = async (email: string, confirmUrl: string) => {
  return sendAuthEmail({
    email,
    type: 'signin',
    confirmUrl
  });
};
